import { PrivilegesListPropsType } from "./type";
import React from "react";
import PrivilegeSource from "shared/enums/PrivilegeSource";
import sortBy from "lodash/sortBy";

export default function usePrivilegesListService(props: PrivilegesListPropsType) {
  const existingPrivilegeIdsList = React.useMemo(() => {
    return props.existingPrivileges
      ?.filter(item => item.privilegeSource?.includes(PrivilegeSource.REGISTRATION_FORM))
      ?.map(i => i.id);
  }, [props.existingPrivileges]);

  const ticketIncludedPrivilegesList = React.useMemo(() => {
    return props.accessPrivileges.filter(item => {
      if (!item.privilegeSource || item.privilegeSource.length === 0) {
        return true;
      } else {
        return item.privilegeSource?.includes(PrivilegeSource.REGISTRATION_FORM);
      }
    });
  }, [props.accessPrivileges]);

  const alreadyIncludedPrivileges = React.useMemo(() => {
    return sortBy(
      ticketIncludedPrivilegesList.filter(item => existingPrivilegeIdsList.includes(item.id)),
      ({ label }) => label.toLowerCase()
    );
  }, [ticketIncludedPrivilegesList, existingPrivilegeIdsList]);

  const newPrivileges = React.useMemo(() => {
    return sortBy(
      ticketIncludedPrivilegesList.filter(item => !existingPrivilegeIdsList.includes(item.id)),
      ({ label }) => label.toLowerCase()
    );
  }, [ticketIncludedPrivilegesList, existingPrivilegeIdsList]);

  return { existingPrivilegeIdsList, ticketIncludedPrivilegesList, alreadyIncludedPrivileges, newPrivileges };
}
